/**
 * Handles Actions triggered by events. Equivalent to redux
 * Only Actions can manipulate the state of a panel
 * This manager only handles actions processing. Individual actions is a service on its own.
 *      -> This allow us to expand the support of more customized actions in future.
 */
(function () {
    'use strict';

    angular
        .module('ActionManager')
        .provider('ActionManager', ActionManager);

    function ActionManager() {

        return {
            setConfig: setConfig,
            $get: ActionManagerGet
        };

        function setConfig() {

        }
    }

    function ActionManagerGet(SodLogger, $injector) {
        return function () {
            if (arguments.length === 0) {
                SodLogger.warn('ActionManager: No Action Name Provided');
                return;
            }

            const actionName = arguments[0];
            const args = Array.prototype.slice.call(arguments, 1);
            const action = $injector.get('action-' + actionName);
            SodLogger.debug('ActionManager', actionName);
            return action.apply(null, args);
        };
    }
})();